import React from 'react';
import heroBg from '@/assets/agents/bg.png';
import agentCard1Video from '@/assets/agents/agent-card-1.mp4';
import agentCard2Video from '@/assets/agents/agent-card-2.mp4';
import agentCard3Video from '@/assets/agents/agent-card-3.mp4';
import agentFeature1 from '@/assets/agents/agent-feature-1.png';
import agentFeature2 from '@/assets/agents/agent-feature-2.png';
import agentFeature3 from '@/assets/agents/agent-feature-3.png';
import agentCourse from '@/assets/agents/agent-course.png';
import agentCourseVideo from '@/assets/agents/digital-video.mp4';
import scenarioBg from '@/assets/agents/scenario-bg.png';
import mentor1 from '@/assets/agents/mentor-1.png';
import mentor2 from '@/assets/agents/mentor-2.png';
import mentor3 from '@/assets/agents/mentor-3.png';
import mentor4 from '@/assets/agents/mentor-4.png';
import mentor5 from '@/assets/agents/mentor-5.png';
import iconContent from '@/assets/agents/icon-content.svg';
import iconPerception from '@/assets/agents/icon-perception.svg';
import iconCommunication from '@/assets/agents/icon-communication.svg';

export const HERO = {
  title: 'AI学习智能体',
  image: heroBg,
  subtitle: (
    <>
      新一代AI互动学习产品。依托于自研的爱学大模型，利用真人级数字人导师，结合多模态感知能力，
      <br />
      构建全年龄、全学科、全方位的智能学习场景，为学习者提供终身学习的个性化成长陪伴。
    </>
  ),
};

export const FEATURE = {
  title: '真人级AI互动，学习新体验',
  subTitle: '自研数字人及语音技术，构造真人级别的AI互动体验',
  cards: [
    {
      title: '集中注意 · 全程不走神',
      description: '短时高频互动，调配学习者注意力。\n将专注力与思考力从“分开动”到“一起动”。',
      video: agentCard1Video,
    },
    {
      title: '及时鼓励 · 激发动力',
      description:
        '创造及时互动反馈，让“理解我，鼓励我”成为学习自信的根本来源，激发学习潜能，强化学习动力。',
      video: agentCard2Video,
    },
    {
      title: '因材施教 · 学有所成',
      description:
        '过程检测掌握情况，随时调整学习难度。\n将难度与学习方法精准结合，支撑多元学习场景。',
      video: agentCard3Video,
    },
  ],
};

export const PERSONALIZED = {
  title: '专属级个性化学习，成长新维度',
  subTitle: '尊重每一位学习者"个体"，构建专属的个性化学习链路',
  items: [
    {
      title: (
        <>
          精细测定
          <br />
          多维能力
        </>
      ),
      description: '基于专业大纲和个人学情等多维测定手段，即时调整教授策略，精准学习薄弱知识。',
      image: agentFeature1,
    },
    {
      title: (
        <>
          分步引导
          <br />
          智能讲授
        </>
      ),
      description: '自研数字人结合爱学大模型，实现AI导师对问题针对性地分步耐心讲解。',
      image: agentFeature2,
    },
    {
      title: (
        <>
          及时回顾
          <br />
          完全掌握
        </>
      ),
      description: '根据学习报告及时回顾学习情况，直观展示知识点掌握和学习互动，复现学习现场。',
      image: agentFeature3,
    },
  ],
};

export const SCENARIO = {
  title: '全自研多场景数字人，应用新标杆',
  subTitle: '融合多模态感知与智能语音交互能力，创造革命性的AI互动体验',
  image: agentCourse,
  background: scenarioBg,
  video: agentCourseVideo,
  cards: [
    {
      icon: iconPerception,
      title: '多模态 · 感知能力',
      description: '通过情绪、姿态识别提供情感化的互动体验，增加用户的参与感。',
    },
    {
      icon: iconContent,
      title: '多场景 · 智能内容',
      description: '多场景下实时生成个性化内容，灵活适配用户反馈，强化学习效果与体验。',
    },
    {
      icon: iconCommunication,
      title: '拟真人 · 互动沟通',
      description: '运用多情感TTS及跨语言技术，提供真实、无障碍的互动沟通体验。',
    },
  ],
};

export const MENTOR = {
  title: '顶尖行业大师，学习有保障',
  subTitle: '沉淀顶尖行业大师方法论，与专业大师协同发力，共同打造领域新标杆',
  cards: [
    {
      image: mentor1,
      role: '思维导师',
      roleColor: '#78a2ee',
      name: '刘梦亚',
      desc: '13年教学经验\n《老梦108招》创始人',
    },
    {
      image: mentor2,
      role: '人文导师',
      roleColor: '#e18e8e',
      name: '杨思思',
      desc: '17年教学经验\n中国人民大学硕士',
    },
    {
      image: mentor3,
      role: '演说导师',
      roleColor: '#eda57e',
      name: '史心语',
      desc: '11年教学经验\n北京大学英语翻译专业硕士',
    },
    {
      image: mentor4,
      role: '科学导师',
      roleColor: '#76d39a',
      name: '杨瑛',
      desc: '19年教学经验\n原全国重点中学物理教研组长',
    },
    {
      image: mentor5,
      role: '实验导师',
      roleColor: '#66d0d6',
      name: '祝鑫',
      desc: '24年教学经验\n中高考把关教师',
    },
  ],
};
